import { render, staticRenderFns } from "./BankCollapseList.vue?vue&type=template&id=7b4c7229&scoped=true"
import script from "./BankCollapseList.vue?vue&type=script&lang=js"
export * from "./BankCollapseList.vue?vue&type=script&lang=js"
import style0 from "./BankCollapseList.vue?vue&type=style&index=0&id=7b4c7229&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4c7229",
  null
  
)

export default component.exports